import React from 'react'
import cx from 'classnames'

import styles from './TableOptions.module.css'
import ActionIcon from './action.svg'
import Dropdown, { DropdownItem, useDropdownContext } from '../Dropdown'

export const TableOption = (props) => {
  return <DropdownItem {...props} />
}

const ActionContainer = (props) => {
  const { getReferenceProps } = useDropdownContext()

  return (
    <div className={cx(styles.ActionContainer, { [styles.Disabled]: props.disabled })}>
      <div className={styles.IconContainer} {...getReferenceProps()}>
        <ActionIcon />
      </div>
    </div>
  )
}

export const TableOptions = (props) => {
  const { children, disabled, ...rest } = props

  return <Dropdown action={<ActionContainer disabled={disabled} />} dropdown={children} {...rest} />
}

export default TableOptions
